import { AppSettings } from "@/AppSettings";
import ParticipantSourceDataFindingsContext from "@/contexts/data/ParticipantSourceDataFindingsContext";
import useItem from "@/hooks/form/source-data/useItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import { Box, Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { ButtonPlaceholder, CounterButton, CounterButtonBox, CounterChip, StyledTooltip } from ".";
import useForm from "@/hooks/form/source-data/useForm";
import { SourceDataFormStatus } from "@/api/dtos";



const SourceDataFormFindingButton: FC<{ 
    form: ReturnType<typeof useForm>;
    itemData?: ReturnType<typeof useItem>; 
    createButtonProps: (link: string) => any 
}> = ({
    form,
    itemData,
    createButtonProps
}) => {
    const { itemMap, loading, validating } = useContext(ParticipantSourceDataFindingsContext);

    const findings = useMemo(() => {
        if (
            !itemData?.studyEventOid || 
            !itemData?.studyEventRepeat || 
            !itemData?.caseReportFormOid || 
            !itemData?.itemGroupRepeat || 
            !itemData?.itemName
        ) {
            return undefined;
        }

        return itemMap?.[itemData.studyEventOid]?.[itemData.studyEventRepeat]?.[itemData.caseReportFormOid!]?.[itemData.itemGroupName ?? AppSettings.metadata.itemGroupUngroupedKey]?.[itemData.itemGroupRepeat!]?.[itemData.itemName];
    }, [ itemMap, itemData?.studyEventOid, itemData?.studyEventRepeat, itemData?.caseReportFormOid, itemData?.itemGroupName, itemData?.itemGroupRepeat, itemData?.itemName ]);

    if (!itemData?.configuration?.allowFindings) {
        return <ButtonPlaceholder />;
    }

    const disabled = !form?.sourceDataForm || form.sourceDataForm.status === SourceDataFormStatus.None || form.sourceDataForm.status === SourceDataFormStatus.Skipped; //!itemData.sourceDataItem;

    let buttonProps: any = createButtonProps(itemData?.preview ? itemData.previewFindingLink : itemData?.dataFindingLink!);

    return (
        <Box>
            <StyledTooltip
                title={
                    disabled ? 
                        'Form does not exist in OpenClinica' :
                        'Findings'
                }
                followCursor
            >
                <CounterButtonBox>
                    <CounterButton
                        variant="outlined"
                        //@ts-ignore
                        {...buttonProps}
                        disabled={disabled}
                    >
                        {!!findings?.length && <CounterChip color="primary">{findings?.length}</CounterChip>}
                        <FontAwesomeIcon icon={AppSettings.icons.finding}  size="2x" />
                    </CounterButton>
                </CounterButtonBox>
            </StyledTooltip>
        </Box>
    );
};

export default SourceDataFormFindingButton;